
import 'core-js';
import 'zone.js';

// https://github.com/swimlane/ngx-charts/issues/240
// IE11 fix
if (typeof SVGElement.prototype.contains === 'undefined') {
   SVGElement.prototype.contains = HTMLDivElement.prototype.contains;
}
